import apiUrl from "./config.json";

const API_KEY = apiUrl.APIKey;

const requests = {
	// Home
	fetchGenre: `/genre/movie/list?api_key=${API_KEY}&language=en-US`,
	fetchTrending: `/trending/all/week?api_key=${API_KEY}&num_votes=2000&language=en-US`,
	fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&num_votes=2000&with_network=213`,
	fetchTopRated: `/movie/top_rated?api_key=${API_KEY}&num_votes=2000&language=en-US`,
	fetchActionMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=28`,
	fetchComedyMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=35`,
	fetchHorrorMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=27`,
	fetchRomanceMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=10749&sort_by=popularity.desc`,
	fetchRecomendattions: `/discover/movie?api_key=${API_KEY}&num_votes=2000&language=en-US&with_genres=27%2C53&sort_by=popularity.desc`,
	fetchMental: `/keyword/41329-mental-illness/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,
	fetchMultiplePersonality: `/keyword/169411-multiple-personality/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,
	fetchTraumaticChildhood: `/keyword/208370-traumatic-childhood/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,

	// Movies page
	fetchNowPlaying: `/movie/now_playing?api_key=${API_KEY}&language=en-US`,
	fetchUpcoming: `/movie/upcoming?api_key=${API_KEY}&language=en-US`,
	fetchPopularMovies: `/movie/popular?api_key=${API_KEY}&language=en-US`,
	fetchAdventureMovies: `/discover/movie?api_key=${API_KEY}&with_genres=12`,
	fetchAnimationMovies: `/discover/movie?api_key=${API_KEY}&with_genres=16`,
	fetchCrimeMovies: `/discover/movie?api_key=${API_KEY}&with_genres=80`,
	fetchDocumentaryMovies: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
	fetchDramaMovies: `/discover/movie?api_key=${API_KEY}&with_genres=18`,
	fetchSciFiMovies: `/discover/movie?api_key=${API_KEY}&with_genres=878`,
	fetchThrillerMovies: `/discover/movie?api_key=${API_KEY}&with_genres=53`,
	fetchWarMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10752`,

	// TV Shows page
	fetchPopularTV: `/tv/popular?api_key=${API_KEY}&language=en-US`,
	fetchTopRatedTV: `/tv/top_rated?api_key=${API_KEY}&language=en-US`,
	fetchOnTheAir: `/tv/on_the_air?api_key=${API_KEY}&language=en-US`,
	fetchAiringToday: `/tv/airing_today?api_key=${API_KEY}&language=en-US`,
	fetchActionTV: `/discover/tv?api_key=${API_KEY}&with_genres=10759`,
	fetchComedyTV: `/discover/tv?api_key=${API_KEY}&with_genres=35`,
	fetchCrimeTV: `/discover/tv?api_key=${API_KEY}&with_genres=80`,
	fetchDocumentaryTV: `/discover/tv?api_key=${API_KEY}&with_genres=99`,
	fetchDramaTV: `/discover/tv?api_key=${API_KEY}&with_genres=18`,
	fetchMysteryTV: `/discover/tv?api_key=${API_KEY}&with_genres=9648`,
	fetchSciFiTV: `/discover/tv?api_key=${API_KEY}&with_genres=10765`,

	// New & Popular
	fetchTrendingDay: `/trending/all/day?api_key=${API_KEY}&language=en-US`,
	fetchTrendingWeek: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
	fetchTrendingMovies: `/trending/movie/week?api_key=${API_KEY}&language=en-US`,
	fetchTrendingTV: `/trending/tv/week?api_key=${API_KEY}&language=en-US`,

	// Anime page (Japanese animation — genre 16 + original language ja)
	fetchAnimePopular: `/discover/tv?api_key=${API_KEY}&with_genres=16&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeTopRated: `/discover/tv?api_key=${API_KEY}&with_genres=16&with_original_language=ja&sort_by=vote_average.desc&vote_count.gte=200`,
	fetchAnimeAction: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C10759&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeComedy: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C35&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeDrama: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C18&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeFantasy: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C10765&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeMystery: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C9648&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeRomance: `/discover/tv?api_key=${API_KEY}&with_genres=16%2C10749&with_original_language=ja&sort_by=popularity.desc`,
	fetchAnimeMovies: `/discover/movie?api_key=${API_KEY}&with_genres=16&with_original_language=ja&sort_by=popularity.desc`,
};

export default requests;
